/**
 * Скачивает файл в браузере
 * @param data - Данные файла (Blob)
 * @param filename - Имя файла для скачивания
 */
export const downloadFile = (data: Blob, filename: string) => {
  try {
    const url = URL.createObjectURL(data)
    const link = document.createElement('a')
    
    link.href = url
    link.download = filename
    link.style.display = 'none'

    document.body.appendChild(link)
    
    // Используем dispatchEvent вместо click() для совместимости с proxy/extensions
    link.dispatchEvent(new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window
    }))

    // Чистим ресурсы через задержку для корректной обработки браузером
    setTimeout(() => {
      try {
        document.body.removeChild(link)
      } catch (e) {
        // Игнорируем ошибку если link уже удален
      }
      URL.revokeObjectURL(url)
    }, 1000)
  } catch (error) {
    console.error('Error downloading file:', error)
    throw new Error('Не удалось скачать файл')
  }
}
